<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rMzESs/tc-custom/9781683508205.jpg?1704717815270" alt="This image is the cover for the book Doctor's Choice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doctor's Choice
      </h1>
      <p class="bookDescription body article font2">
        <i>Doctor's Choice</i> helps overwhelmed doctors discover the crucial steps they need to take to get clarity and find balance. Often, doctors’ relationships and health suffer due to excessive work-related stress and demands—sometimes even driving them to quit their practice. Is it even possible to be a doctor and also live a happy, stress-free life? Dr. Maritta Philp had been working as a doctor for over 20 years before the intensity and stress of modern medical practice inspired her to take a long, hard look at where the road she was on would lead. She realized the final destination for her would be one of burn-out and resentment, causing her to make different choices for her life and career. Maritta is passionate about enabling people to create a life they can be in love with, a life that reflects their most important ideas and values. <i>Doctor's Choice</i> explores in a no-nonsense manner the issues affecting today's doctors in a world of ever-increasing patient demand. Balancing the need to look after patients and themselves is a challenge which doctors need to meet for the benefit of all.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maritta Philp, Marisa Peer
      </h2>
      
      <p class="authorDescription body article">Dr. Maritta Philp, MD, had worked as a doctor for over 20 years before the intensity and stress of modern medical practice inspired her to take a long, hard look at where the road she was on would lead. She now works as a successful coach and therapist, helping people to identify and overcome their own obstacles and enabling them to step into a self-directed and empowered life. Dr. Philp also runs workshops and speaks on related topics. Born in Germany, Maritta moved to the UK in 1996 to complete her specialist training. She moved to Scotland soon after, where she still lives with her husband, two beautiful daughters, and her dog Maisie. www.marittaphilp.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5486ad7e